// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d426c0a8","732":"8ec75b7a"}[chunkId] + ".chunk.js";
};